import accountsIcon from "../../assets/icons/accountsIcon.svg";
import businessIcon from "../../assets/icons/businessIcon.svg";
import detailIcon from "../../assets/icons/detailIcon.svg";
import exportIcon from "../../assets/icons/export.svg";
import formIcon from "../../assets/icons/formIcon.svg";
import gatewayIcon from "../../assets/icons/gatewayIcon.svg";
import listIcon from "../../assets/icons/listIcon.svg";
import marketingIcon from "../../assets/icons/marketing.svg";
import notificationIcon from "../../assets/icons/notification.svg";
import plusIcon from "../../assets/icons/plusIcon.svg";
import profileIcon from "../../assets/icons/profileIcon.svg";
import settelIcon from "../../assets/icons/settelIcon.svg";
import trackIcon from "../../assets/icons/trackIcon.svg";
import cahtIcon from "../../assets/images/cahtIcon.svg";

export const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled ? "#F5F5F5" : "white", // Change the background color when disabled
    height: "52px",
    boxShadow: state.isDisabled ? "none" : "gray",
    borderWidth: "1px",
    borderRadius: "8px",
    borderColor: state.isDisabled ? "#F5F5F5" : "#cccccc",
    "&:hover": {
      borderColor: "#cccccc",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "white",
    color: state.isSelected ? "black" : "gray",
    borderColor: "#cccccc",
    boxShadow: state.isSelected ? "white" : "black",
    "&:hover": {
      backgroundColor: "#cccccc",
      borderColor: "#cccccc",
    },
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#a8a8a8" : "gray", // Adjust color when disabled
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "black" : "black", // Adjust color when disabled
  }),
};
export const userDefaultValues = {
  first_name_fa: "",
  last_name_fa: "",
  first_name_en: "",
  last_name_en: "",
  father_name_fa: "",
  father_name_en: "",
  national_code: "",
  birthdate: "",
  is_iranian: true,
  foreign_pervasive_code: "",
  passport_number: "",
  passport_expire_date: "",
  passport_image: { url: "", preview_url: "" },
  top_national_card_image: { url: "", preview_url: "" },
  first_birth_certificate_page_image: { url: "", preview_url: "" },
  profile_picture: { url: "", preview_url: "" },
  countrycode_id: 0,
  id: 0,
  mobile: "",
  email: "",
  active: false,
  verified: false,
  banned: false,
  vanda_wallet_user: false,
  is_email_verified: true,
  role: 1,
};

export const bussinessDefaultValues = {
  is_real: true,
  fa_name: "",
  en_name: "",
  address: "",
  phone: "",
  postal_code: "",
  logo: { url: "", preview_url: "" },
  business_license_image: { url: "", preview_url: "" },
  announcement_image: { url: "", preview_url: "" },
  last_announcement_image: { url: "", preview_url: "" },
  register_code: "",
  register_date: "",
  national_id: "",
  tax_code: "",
  account_id: 0,
  category_id: 0,
};

export const authFormOption = [
  { title: "ایرانی", value: true },
  { title: "غیرایرانی", value: false },
];

export const businessFormOption = [
  { title: "حقیقی", value: true },
  { title: "حقوقی", value: false },
];

export const settlementSettingOption = [
  { title: "دستی", value: 2 },
  { title: "اتوماتیک", value: 1 },
];

export const settlementScheduleOption = [
  { value: 1, title: "روزانه" },
  { value: 2, title: "هفتگی" },
  { value: 3, title: "ماهانه" },
];
export const weekOption = [
  { value: 1, title: "شنبه" },
  { value: 2, title: "یکشنبه" },
  { value: 3, title: "دوشنبه" },
  { value: 4, title: "سه‌شنبه" },
  { value: 5, title: "چهارشنبه" },
  { value: 6, title: "پنجشنبه" },
  { value: 7, title: "جمعه" },
];

export const authIranianItems = [
  { title: "تصویر آواتار", value: "profile_picture", active: true },
  { title: "کارت ملی", value: "top_national_card_image", active: false },
  {
    title: "شناسنامه",
    value: "first_birth_certificate_page_image",
    active: false,
  },
];

export const authNonIranianItems = [
  { title: "تصویر آواتار", value: "profile_picture", active: true },
  { title: "گذرنامه", value: "passport_image", active: false },
];

export const businessRealItems = [
  { title: "تصویر آواتار", value: "logo", active: true },
  {
    title: "  جواز کسب (اختیاری)",
    value: "business_license_image",
    active: false,
  },
];

export const businessLegalItems = [
  { title: "تصویر آواتار", value: "logo", active: true },
  { title: "  آگهی تاسیس ", value: "announcement_image", active: false },
  {
    title: " آگهی آخرین تغیییرات",
    value: "last_announcement_image",
    active: false,
  },
  {
    title: "  جواز کسب (اختیاری)",
    value: "business_license_image",
    active: false,
  },
];

export const userNavbarItems = [
  {
    id: 1,
    title: "ناحیه کاربری ",
    path: "/profile",
    active: true,
    icon: profileIcon,
    subNav: [],
  },
  {
    id: 2,
    title: "حساب های بانکی",
    path: "/accounts",
    active: false,
    icon: accountsIcon,
    subNav: [
      {
        id: 1,
        title: "لیست",
        path: "/list",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: "ثبت حساب بانکی جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 5,
    title: " کسب و کار",
    path: "/business",
    active: true,
    icon: businessIcon,
    subNav: [
      {
        id: 1,
        title: "کسب و کارها",
        path: "/list",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: " ثبت کسب و کار جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "پشتیبانی",
    path: "/tickets",
    active: false,
    icon: cahtIcon,
    subNav: [
      {
        id: 1,
        title: "لیست تیکت ها",
        path: "/list",
        icon: listIcon,
        active: false,
      },
      {
        id: 2,
        title: "ثبت  تیکت جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "پیام ها",
    path: "/messages",
    active: false,
    icon: notificationIcon,
    subNav: [
      {
        id: 1,
        title: "اعلانات",
        path: "/notif",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: "پیام های شخصی",
        path: "/inbox",
        icon: listIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "بازاریابی",
    path: "/marketing",
    active: false,
    icon: marketingIcon,
    subNav: [
      {
        id: 1,
        title: "کاربران من",
        path: "/users",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: "تسویه های من",
        path: "/settlements",
        icon: listIcon,
        active: false,
      },
    ],
  },
];
export const bussinessNavbarItems = [
  {
    id: 1,
    title: "مشخصات کسب و کار",
    path: "/business/detail/",
    active: false,
    icon: detailIcon,
    subNav: [],
  },
  {
    id: 2,
    title: "درگاه ها ",
    path: "/gateway",
    active: false,
    icon: gatewayIcon,
    subNav: [
      {
        id: 1,
        title: "لیست",
        path: "/list/",
        icon: listIcon,
        active: false,
      },
      {
        id: 2,
        title: "درگاه جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 3,
    title: "فرم ها",
    path: "/forms",
    active: false,
    icon: formIcon,
    subNav: [
      {
        id: 1,
        title: "لیست",
        path: "/list/",
        icon: listIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "تراکنش ها",
    path: "/transactions",
    active: true,
    icon: trackIcon,
    subNav: [],
  },
  {
    id: 5,
    title: "تسویه ها",
    path: "/settlement",
    active: false,
    icon: settelIcon,
    subNav: [
      {
        id: 1,
        title: "لیست",
        path: "/list/",
        icon: listIcon,
        active: false,
      },
      {
        id: 2,
        title: "ایجاد تسویه جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 6,
    title: "لیست خروجی ها",
    path: "/exports",
    active: true,
    icon: exportIcon,
    subNav: [],
  },
];
export const posBussinessNavbarItems = [
  {
    id: 1,
    title: "مشخصات کسب و کار",
    path: "/business/detail/",
    active: false,
    icon: detailIcon,
    subNav: [],
  },
  {
    id: 2,
    title: "دستگاه های من",
    path: "/terminals",
    active: false,
    icon: gatewayIcon,
    subNav: [],
  },

  {
    id: 3,
    title: "تراکنش ها",
    path: "/pos-transactions",
    active: true,
    icon: trackIcon,
    subNav: [],
  },
  {
    id: 4,
    title: "تسویه ها",
    path: "/settlement",
    active: false,
    icon: settelIcon,
    subNav: [
      {
        id: 1,
        title: "لیست",
        path: "/list/",
        icon: listIcon,
        active: false,
      },
      {
        id: 2,
        title: "ایجاد تسویه جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 5,
    title: "لیست خروجی ها",
    path: "/exports",
    active: true,
    icon: exportIcon,
    subNav: [],
  },
];

export const activeOptions = [
  { value: true, label: "فعال", class: "text-success-60" },
  { value: false, label: "غیرفعال", class: "text-error-90" },
];

export const gatwayTicketStatusOptions = [
  {
    value: "approved",
    label: "تایید شده",
    class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: "pending",
    label: "درحال بررسی ",
    class: "text-secondary-90 bg-[#CED3D9] rounded-md px-[10px] py-1 min-w-[100px]",
  },
  {
    value: "denied",
    label: "رد شدع",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
];

export const settlementStateOptions = [
  { value: "", label: "همه", class: "" },
  { value: true, label: "موفق", class: "text-success-60" },
  { value: false, label: "ناموفق", class: "text-error-90" },
];
export const transactionTerminalOptions = [
  { value: "form", label: "فرم", class: "" },
  { value: "pos", label: "کارتخوان", class: "" },
  { value: "gateway", label: "درگاه", class: "" },
];
export const transactionStateOptions = [
  { value: "", label: "همه", class: "" },
  {
    value: "success",
    label: "موفق",
    class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: "failed",
    label: "ناموفق",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
  {
    value: "in_progress",
    label: "درحال انجام",
    class: "text-secondary-90 bg-[#CED3D9] rounded-md px-[10px] py-1 min-w-[100px]",
  },
];

export const settlementOptions = [
  {
    value: "paid",
    label: "پرداخت شده",
    class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: "pending",
    label: "درحال بررسی ",
    class: "text-secondary-90 bg-[#CED3D9] rounded-md px-[10px] py-1 min-w-[100px]",
  },
  {
    value: "cancelled",
    label: "رد شده",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
  {
    value: "wallet_queue",
    label: "درانتظارانتقال به ولت",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
  {
    value: "partial_paid",
    label: "",
    class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
  },
];
export const settlementStatusOptions = [
  { value: "", label: "همه", class: "" },
  { value: "paid", label: "پرداخت شده", class: "text-success-60" },
  {
    value: "pending_for_settlement",
    label: "درانتظار تسویه",
    class: "text-error-90",
  },
  { value: "submitted", label: "آماده تسویه", class: "text-warning-100" },
];
export const verifiedByUserOptions = [
  { value: "", label: "همه", class: "" },
  { value: "true", label: " تایید", class: "text-error-90" },
  { value: "false", label: "عدم تایید", class: "text-warning-100" },
];

export const gatewayTypeOptions = [
  { value: "", label: "همه", class: "" },
  { value: "gateway", label: "درگاه", class: "" },
  { value: "pos", label: "کارتخوان", class: "" },
  { value: "submitted", label: "ثبت شده", class: "" },
];

export const ExcelFormFields = [
  { label: "نام فارسی", value: "first_name_fa" },
  { label: "نام خانوادگی فارسی", value: "last_name_fa" },
  { label: "نام انگلیسی", value: "first_name_en" },
  { label: "نام خانوادگی انگلیسی", value: "last_name_en" },
  { label: "کدملی", value: "national_code" },
  { label: "تاریخ تولد", value: "birthdate" },
  { label: "ملیت", value: "is_iranian" },
  { label: "ایمیل", value: "email" },
  { label: "موبایل", value: "mobile" },
  { label: "فعال/غیرفعال", value: "active" },
  { label: "وضعیت مسدودی", value: "verified" },
  { label: "وضعیت احراز هویت", value: "banned" },
  { label: "نقش", value: "role" },
];
export const transactionsExcelFormFields = [
  { label: "همه", value: "all" },
  { label: "تاریخ پرداخت", value: "invoice_time" },
  { label: "مبلغ", value: "amount" },
  { label: "شماره کارت", value: "card_number" },
  { label: "وضعیت تراکنش", value: "transaction_state" },
  { label: "وضعیت تسویه", value: "settlement_status" },
  { label: "شماره پیگیری وندا", value: "vanda_tracking_code" },
  { label: "شناسه سفارش", value: "order_number" },
  { label: "آدرس باز گشتی", value: "reference_number" },
  { label: "نام پرداخت کننده", value: "payer_name" },
  { label: "شماره پرداخت کننده", value: "payer_mobile" },
  { label: "ایمیل پرداخت کننده", value: "payer_mail" },
  { label: "توضیحات پرداخت کننده", value: "payer_description" },
  { label: "آدرس پرداخت کننده", value: "payer_address" },
  { label: "کدملی پرداخت کننده", value: "payer_national_code" },
  { label: "کدپستی پرداخت کننده", value: "payer_postal_code" },
];

export const transactionFieldLabels = {
  from_invoice_time: "تاریخ پرداخت از",
  to_invoice_time: "تا",
  from_payment_time: "تاریخ پرداخت از",
  to_payment_time: "تا",
  from_amount: "از مبلغ",
  to_amount: "تا مبلغ",
  exact_amount: "مبلغ دقیق",
  invoice_number: "شناسه پرداخت",
  order_number: "شماره سفارش",
  payer_name: "نام پرداخت کننده",
  payer_mail: "ایمیل پرداخت کننده",
  payer_mobile: "مویایل پرداخت کننده",
  national_code: "کدملی پرداخت کننده",
  gateway_id: "شناسه درگاه",
  form_id: "شناسه فرم",
  user_id: "شناسه کاربر",
  reference_number: "کدارجاع بانک",
  track_id: "کدرهگیری بانک",
  card_number: "شماره کارت",
  user_fullname: "نام پرداخت کننده",
  vanda_tracking_code: "شناسه وندا",
  transaction_state: "وضعیت تراکنش",
  settlement_status: "وضعیت تسویه",
  transaction_type: "نوع تراکنش",
  verified_by_user: " تایید از سوی پذیرنده",
};

export const portStepOption = [
  { title: "تنطیمات عمومی", value: 1 },
  { title: "امور مالی", value: 2 },
  { title: "تنظیم ورودی ها", value: 3 },
];

export const portAmountOption = [
  { title: "ثابت", value: true },
  { title: "متغیر", value: false },
];
export const portWageAmountOption = [
  { title: "خودم", value: true },
  { title: "مشتری", value: false },
];
export const portSettingOption = [
  { title: "اجباری", value: true },
  { title: "اختیاری", value: false },
];

export const portDefaultValues = {
  fixed_amount: false,
  form_amount: "",
  display_payer_name: false,
  is_payer_name_mandatory: false,
  display_payer_phone: false,
  is_payer_phone_mandatory: false,
  display_payer_email: false,
  is_payer_email_mandatory: false,
  display_payer_address: false,
  is_payer_address_mandatory: false,
  is_expendable: false,
  expire_time: "",
  display_expire_time: false,
  has_target_amount: false,
  target_amount: "",
  display_target_amount: false,
  is_wage_on_owner: true,
  display_wage_payer: false,
  // realbusiness_id: 0,
  // legalbusiness_id: 0,
  display_national_code: false,
  is_national_code_mandatory: false,
  display_postal_code: false,
  is_postal_code_mandatory: false,
  name: "",
  link: "",
  image: "",
  description: "",
};

export const mobileNavbarItems = [
  {
    id: 1,
    title: "کسب وکار",
    path: "/business/list",
    active: true,
    icon: "/images/businessbriefcase.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "اعلانات",
    path: "/notices",
    active: true,
    icon: "/images/notification.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "حساب بانکی",
    path: "/accounts/list",
    active: true,
    icon: "/images/cards.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "پشتیبانی",
    path: "/tickets/list",
    active: true,
    icon: "/images/customersupport.svg",
    subNav: [],
  },
  {
    id: 1,
    title: "پروفایل",
    path: "/profile",
    active: true,
    icon: "/images/profileicon.svg",
    subNav: [],
  },
];

export const EmailNoticeSetting = [
  {
    type: "email",
    id: "settelment",
    label: "تسویه‌حساب‌ها",
    description: "برای هر وجهی که از حساب‌های شما خارج می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "email",
    id: "transaction",
    label: "واریز‌ها",
    description: "برای هر وجهی که به حساب‌های شما واریز می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "email",
    id: "login",
    label: "ورود به نرم‌افزار",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "email",
    id: "news",
    label: "اخبار",
    description: "برای تمامی اخبار وندا یک اعلان دریافت خواهید کرد",
    active: false,
  },
  {
    type: "email",
    id: "announcement",
    label: "اعلانیه",
    description: "برای تمامی اعلانیه‌های مربوط به شما یک اعلان دریافت خواهید کرد",
    active: false,
  },
  {
    type: "email",
    id: "ticket",
    label: "تیکت",
    description: "برای پاسخ تیکت‌ها یک اعلان دریافت خواهید کرد",
    active: false,
  },
];
export const SmsNoticeSetting = [
  {
    type: "sms",
    id: "settelment",
    label: "تسویه‌حساب‌ها",
    description: "برای هر وجهی که از حساب‌های شما خارج می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "sms",
    id: "transaction",
    label: "واریز‌ها",
    description: "برای هر وجهی که به حساب‌های شما واریز می‌شود یک اعلان دریافت خواهید کرد.",
    active: false,
  },
  {
    type: "sms",
    id: "login",
    label: "ورود به نرم‌افزار",
    description: "با هر بار ورود به نرم‌افزار یک اعلان امنیتی دریافت خواهید کرد.",
    active: false,
  },
];

export const exportModelOptions = [
  {
    value: "transaction",
    label: "تراکنش",
    class: "text-secondary-90 bg-secondary-10 rounded-md px-[10px] py-1",
  },
  {
    value: "settlment",
    label: "تسویه",
    class: "text-secondary-90 bg-secondary-10 rounded-md px-[10px] py-1 min-w-[100px]",
  },
];

export const exportPrcessedOptions = [
  {
    value: true,
    label: "پردازش موفق",
    class: "text-success-90 bg-success-10 rounded-md px-[10px] py-1",
  },
  {
    value: false,
    label: "در حال پردازش",
    class: "text-secondary-90 bg-secondary-10 rounded-md px-[10px] py-1 min-w-[100px]",
  },
];
export const profileNotificationDefaultValues = {
  email_on_login: false,
  email_on_business_denial: false,
  email_on_broad_notification: false,
  sms_on_business_denial: false,
  email_on_news: false,
  email_on_gateway_approval: false,
  sms_on_settlement: false,
  sms_on_gateway_approval: false,
  sms_on_broad_notification: false,
  email_on_message: false,
  email_on_gateway_denial: false,
  sms_on_transaction: false,
  sms_on_gateway_denial: false,
  sms_on_ticket: false,
  email_on_ticket: false,
  email_on_account_approval: false,
  sms_on_login: false,
  sms_on_account_approval: false,
  email_on_failed_login: false,
  email_on_account_denial: false,
  sms_on_failed_login: false,
  sms_on_account_denial: false,
  email_on_verify: false,
  email_on_form_approval: false,
  sms_on_verify: false,
  sms_on_form_approval: false,
  email_on_settlement: false,
  email_on_failed_verify: false,
  email_on_form_denial: false,
  sms_on_failed_verify: false,
  sms_on_form_denial: false,
  email_on_transaction: false,
  email_on_business_approval: false,
  email_on_settlement_change: false,
  sms_on_business_approval: false,
  sms_on_settlement_change: false,
};

export const userAdminStatusoptions = [
  {
    option: "approved",
    text: "مورد تایید ونداپرداخت",
    style:
      "bg-success-10 w-full  flex px-6 py-2 rounded-md text-success-90 text-center justify-center items-center gap-2 ",
    imgSrc: "/icons/approved-icon.svg",
  },
  {
    option: "pending",
    text: "در انتظار بررسی ونداپرداخت",
    style: "bg-warning-10 w-full  flex px-6 py-2 rounded-md text-center justify-center items-center gap-2  ",
    imgSrc: "/icons/pending-icon.svg",
  },
  {
    option: "denied",
    text: "رد شده توسط ونداپرداخت",
    style:
      "bg-error-10  w-full  flex px-6 py-2 rounded-md text-error-90 text-center justify-center items-center gap-2",
    imgSrc: "/icons/denied-icon.svg",
  },
];

export const userActiveStatusoptions = [
  {
    option: true,
    text: "فعال",
    style:
      "bg-success-10 w-full  flex px-6 py-2 rounded-md text-success-90 text-center justify-center items-center gap-2 ",
    imgSrc: "/icons/active-icon.svg",
  },
  {
    option: false,
    text: "غیرفعال",
    style: "bg-warning-10 w-full  flex px-6 py-2 rounded-md text-center justify-center items-center gap-2  ",
    imgSrc: "/icons/disactive-icon.svg",
  },
];

export const transactionSearchTermDefaultValues = {
  exclude_transaction_type: "pos",
  transaction_state: "",
  settlement_status: "",
  from_invoice_time: "",
  to_invoice_time: "",
  from_amount: "",
  to_amount: "",
  exact_amount: "",
  invoice_number: "",
  payer_name: "",
  payer_mail: "",
  payer_mobile: "",
  payer_national_code: "",
  gateway_id: "",
  form_id: "",
  user_id: "",
  reference_number: "",
  track_id: "",
  card_number: "",
  user_fullname: "",
  vanda_tracking_code: "",
  verified_by_user: "",
  order_by: "invoice_time",
  descending: true,
};
